import { forEach, camelCase } from 'lodash';
import { Dispatch } from 'react';
import { viewSizes } from '../../hooks/useViewSize';

export function validateForm(formState: any) {
  const {
    firstName, lastName, country, postalCode,
  } = formState;

  if (
    firstName.trim().length === 0
        || lastName.trim().length === 0
        || country.trim().length === 0
        || postalCode.trim().length === 0
  ) {
    return false;
  }
  return true;
}

export const getErrorMessage = (code: string, field: string) => {
    type PlotOptions = {
      [key: string]: string
    };
    const displayMap: PlotOptions = {
      first_name: 'first name',
      last_name: 'last name',
      number: 'credit card number',
      month: 'expire date',
      year: 'expire date',
      cvv: 'CVV',
      postal_code: 'zip code',
      country: 'country',
    };

    if (code === 'validation') {
      return 'This is a required field.';
    }
    return `Please enter a valid ${displayMap[field]}.`;
};

const onRecurlyError = (
  error: any,
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>,
  handleErrors: (error: any) => void,
) => {
  setSubmitting(false);
  handleErrors(error);
};

export const parseRecurlyErrors = (
  err: any,
  setSubmitting: React.Dispatch<React.SetStateAction<boolean>>,
  handleErrors: (error: any) => void,
) => {
  const { details, message, code } = err;
  if (message === 'Cvv must be three digits' || message === 'Cvv must be four digits') {
    return onRecurlyError({ cvv: 'Please enter a valid CVV.' }, setSubmitting, handleErrors);
  }

  return forEach(details, (d) => onRecurlyError({
    [camelCase(d.field)]: getErrorMessage(code, d.field),
  }, setSubmitting, handleErrors));
};

export const showApplePay = (
  flags: any,
  setShowApplePayOption: Dispatch<React.SetStateAction<boolean>>,
// eslint-disable-next-line consistent-return
): void => {
  if (!flags.enableApplePaySocialEcomm) {
    return setShowApplePayOption(false);
  }
  // Check if user is on Apple device to display/enable Apple Pay
  const ua = navigator.userAgent;
  const isIPhone = ua.match(/iPhone/i);
  const webkit = !!ua.match(/WebKit/i);
  const applePayAvailable = isIPhone && webkit && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i);
  if (applePayAvailable && window.ApplePaySession) {
    const merchantIdentifierRoot = document.location.hostname.split('.')[0];
    const merchantIdentifier = `merchant.com.${merchantIdentifierRoot}`;
    const promise = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantIdentifier);
    promise.then((canMakePayments: boolean) => {
      if (canMakePayments) {
        setShowApplePayOption(true);
      }
    });
  }
};

export const isMobile = (viewSize: string) => viewSize === viewSizes.extraSmall;
